// src/constants/packSizes.js
export const TYPE_OPTIONS = [
  "Tablet",
  "Capsule",
  "Syrup",
  "Suspension",
  "Injection",
  "Infusion",
  "Cream",
  "Ointment",
  "Gel",
  "Lotion",
  "Drops (Eye)",
  "Drops (Ear)",
  "Drops (Nasal)",
  "Inhaler",
  "Respules",
  "Rotacaps",
  "Sachet",
  "Powder",
  "Spray",
  "Soap",
  "Shampoo",
  "Other"
];

export const PACK_SIZES_BY_TYPE = {
  "Tablet": [
    {
      "label": "1",
      "count": 1,
      "unit": ""
    },
    {
      "label": "2",
      "count": 2,
      "unit": ""
    },
    {
      "label": "3",
      "count": 3,
      "unit": ""
    },
    {
      "label": "4",
      "count": 4,
      "unit": ""
    },
    {
      "label": "6",
      "count": 6,
      "unit": ""
    },
    {
      "label": "10",
      "count": 10,
      "unit": ""
    },
    {
      "label": "15",
      "count": 15,
      "unit": ""
    },
    {
      "label": "20",
      "count": 20,
      "unit": ""
    },
    {
      "label": "30",
      "count": 30,
      "unit": ""
    },
    {
      "label": "40",
      "count": 40,
      "unit": ""
    },
    {
      "label": "50",
      "count": 50,
      "unit": ""
    },
    {
      "label": "60",
      "count": 60,
      "unit": ""
    },
    {
      "label": "90",
      "count": 90,
      "unit": ""
    },
    {
      "label": "100",
      "count": 100,
      "unit": ""
    },
    {
      "label": "120",
      "count": 120,
      "unit": ""
    },
    {
      "label": "200",
      "count": 200,
      "unit": ""
    },
    {
      "label": "500",
      "count": 500,
      "unit": ""
    }
  ],
  "Capsule": [
    {
      "label": "1",
      "count": 1,
      "unit": ""
    },
    {
      "label": "2",
      "count": 2,
      "unit": ""
    },
    {
      "label": "3",
      "count": 3,
      "unit": ""
    },
    {
      "label": "4",
      "count": 4,
      "unit": ""
    },
    {
      "label": "6",
      "count": 6,
      "unit": ""
    },
    {
      "label": "10",
      "count": 10,
      "unit": ""
    },
    {
      "label": "15",
      "count": 15,
      "unit": ""
    },
    {
      "label": "20",
      "count": 20,
      "unit": ""
    },
    {
      "label": "30",
      "count": 30,
      "unit": ""
    },
    {
      "label": "40",
      "count": 40,
      "unit": ""
    },
    {
      "label": "50",
      "count": 50,
      "unit": ""
    },
    {
      "label": "60",
      "count": 60,
      "unit": ""
    },
    {
      "label": "90",
      "count": 90,
      "unit": ""
    },
    {
      "label": "100",
      "count": 100,
      "unit": ""
    },
    {
      "label": "120",
      "count": 120,
      "unit": ""
    },
    {
      "label": "200",
      "count": 200,
      "unit": ""
    },
    {
      "label": "500",
      "count": 500,
      "unit": ""
    }
  ],
  "Syrup": [
    {
      "label": "30 ml",
      "count": 30,
      "unit": "ml"
    },
    {
      "label": "60 ml",
      "count": 60,
      "unit": "ml"
    },
    {
      "label": "100 ml",
      "count": 100,
      "unit": "ml"
    },
    {
      "label": "120 ml",
      "count": 120,
      "unit": "ml"
    },
    {
      "label": "150 ml",
      "count": 150,
      "unit": "ml"
    },
    {
      "label": "200 ml",
      "count": 200,
      "unit": "ml"
    },
    {
      "label": "250 ml",
      "count": 250,
      "unit": "ml"
    },
    {
      "label": "300 ml",
      "count": 300,
      "unit": "ml"
    },
    {
      "label": "450 ml",
      "count": 450,
      "unit": "ml"
    },
    {
      "label": "500 ml",
      "count": 500,
      "unit": "ml"
    }
  ],
  "Suspension": [
    {
      "label": "30 ml",
      "count": 30,
      "unit": "ml"
    },
    {
      "label": "60 ml",
      "count": 60,
      "unit": "ml"
    },
    {
      "label": "100 ml",
      "count": 100,
      "unit": "ml"
    },
    {
      "label": "120 ml",
      "count": 120,
      "unit": "ml"
    },
    {
      "label": "150 ml",
      "count": 150,
      "unit": "ml"
    },
    {
      "label": "200 ml",
      "count": 200,
      "unit": "ml"
    },
    {
      "label": "250 ml",
      "count": 250,
      "unit": "ml"
    },
    {
      "label": "300 ml",
      "count": 300,
      "unit": "ml"
    },
    {
      "label": "450 ml",
      "count": 450,
      "unit": "ml"
    },
    {
      "label": "500 ml",
      "count": 500,
      "unit": "ml"
    }
  ],
  "Injection": [
    {
      "label": "1 ml",
      "count": 1,
      "unit": "ml"
    },
    {
      "label": "2 ml",
      "count": 2,
      "unit": "ml"
    },
    {
      "label": "5 ml",
      "count": 5,
      "unit": "ml"
    },
    {
      "label": "10 ml",
      "count": 10,
      "unit": "ml"
    },
    {
      "label": "20 ml",
      "count": 20,
      "unit": "ml"
    },
    {
      "label": "30 ml",
      "count": 30,
      "unit": "ml"
    },
    {
      "label": "50 ml",
      "count": 50,
      "unit": "ml"
    },
    {
      "label": "100 ml",
      "count": 100,
      "unit": "ml"
    }
  ],
  "Infusion": [
    {
      "label": "50 ml",
      "count": 50,
      "unit": "ml"
    },
    {
      "label": "100 ml",
      "count": 100,
      "unit": "ml"
    },
    {
      "label": "250 ml",
      "count": 250,
      "unit": "ml"
    },
    {
      "label": "500 ml",
      "count": 500,
      "unit": "ml"
    },
    {
      "label": "1000 ml",
      "count": 1000,
      "unit": "ml"
    }
  ],
  "Cream": [
    {
      "label": "5 g",
      "count": 5,
      "unit": "g"
    },
    {
      "label": "10 g",
      "count": 10,
      "unit": "g"
    },
    {
      "label": "15 g",
      "count": 15,
      "unit": "g"
    },
    {
      "label": "20 g",
      "count": 20,
      "unit": "g"
    },
    {
      "label": "25 g",
      "count": 25,
      "unit": "g"
    },
    {
      "label": "30 g",
      "count": 30,
      "unit": "g"
    },
    {
      "label": "50 g",
      "count": 50,
      "unit": "g"
    },
    {
      "label": "100 g",
      "count": 100,
      "unit": "g"
    }
  ],
  "Ointment": [
    {
      "label": "5 g",
      "count": 5,
      "unit": "g"
    },
    {
      "label": "10 g",
      "count": 10,
      "unit": "g"
    },
    {
      "label": "15 g",
      "count": 15,
      "unit": "g"
    },
    {
      "label": "20 g",
      "count": 20,
      "unit": "g"
    },
    {
      "label": "25 g",
      "count": 25,
      "unit": "g"
    },
    {
      "label": "30 g",
      "count": 30,
      "unit": "g"
    },
    {
      "label": "50 g",
      "count": 50,
      "unit": "g"
    },
    {
      "label": "100 g",
      "count": 100,
      "unit": "g"
    }
  ],
  "Gel": [
    {
      "label": "5 g",
      "count": 5,
      "unit": "g"
    },
    {
      "label": "10 g",
      "count": 10,
      "unit": "g"
    },
    {
      "label": "15 g",
      "count": 15,
      "unit": "g"
    },
    {
      "label": "20 g",
      "count": 20,
      "unit": "g"
    },
    {
      "label": "25 g",
      "count": 25,
      "unit": "g"
    },
    {
      "label": "30 g",
      "count": 30,
      "unit": "g"
    },
    {
      "label": "50 g",
      "count": 50,
      "unit": "g"
    },
    {
      "label": "100 g",
      "count": 100,
      "unit": "g"
    }
  ],
  "Lotion": [
    {
      "label": "5 ml",
      "count": 5,
      "unit": "ml"
    },
    {
      "label": "10 ml",
      "count": 10,
      "unit": "ml"
    },
    {
      "label": "15 ml",
      "count": 15,
      "unit": "ml"
    },
    {
      "label": "20 ml",
      "count": 20,
      "unit": "ml"
    },
    {
      "label": "25 ml",
      "count": 25,
      "unit": "ml"
    },
    {
      "label": "30 ml",
      "count": 30,
      "unit": "ml"
    },
    {
      "label": "50 ml",
      "count": 50,
      "unit": "ml"
    },
    {
      "label": "100 ml",
      "count": 100,
      "unit": "ml"
    }
  ],
  "Drops (Eye)": [
    {
      "label": "5 ml",
      "count": 5,
      "unit": "ml"
    },
    {
      "label": "10 ml",
      "count": 10,
      "unit": "ml"
    },
    {
      "label": "15 ml",
      "count": 15,
      "unit": "ml"
    }
  ],
  "Drops (Ear)": [
    {
      "label": "5 ml",
      "count": 5,
      "unit": "ml"
    },
    {
      "label": "10 ml",
      "count": 10,
      "unit": "ml"
    },
    {
      "label": "15 ml",
      "count": 15,
      "unit": "ml"
    }
  ],
  "Drops (Nasal)": [
    {
      "label": "5 ml",
      "count": 5,
      "unit": "ml"
    },
    {
      "label": "10 ml",
      "count": 10,
      "unit": "ml"
    },
    {
      "label": "15 ml",
      "count": 15,
      "unit": "ml"
    }
  ],
  "Inhaler": [
    {
      "label": "60 doses",
      "count": 60,
      "unit": "doses"
    },
    {
      "label": "100 doses",
      "count": 100,
      "unit": "doses"
    },
    {
      "label": "120 doses",
      "count": 120,
      "unit": "doses"
    },
    {
      "label": "200 doses",
      "count": 200,
      "unit": "doses"
    }
  ],
  "Respules": [
    {
      "label": "2 ml respule",
      "count": 2,
      "unit": "ml"
    },
    {
      "label": "3 ml respule",
      "count": 3,
      "unit": "ml"
    }
  ],
  "Rotacaps": [
    {
      "label": "30 capsules",
      "count": 30,
      "unit": "capsules"
    },
    {
      "label": "60 capsules",
      "count": 60,
      "unit": "capsules"
    }
  ],
  "Sachet": [
    {
      "label": "1 g",
      "count": 1,
      "unit": "g"
    },
    {
      "label": "2 g",
      "count": 2,
      "unit": "g"
    },
    {
      "label": "4 g",
      "count": 4,
      "unit": "g"
    },
    {
      "label": "5 g",
      "count": 5,
      "unit": "g"
    },
    {
      "label": "10 g",
      "count": 10,
      "unit": "g"
    },
    {
      "label": "20 g",
      "count": 20,
      "unit": "g"
    }
  ],
  "Powder": [
    {
      "label": "1 g",
      "count": 1,
      "unit": "g"
    },
    {
      "label": "2 g",
      "count": 2,
      "unit": "g"
    },
    {
      "label": "4 g",
      "count": 4,
      "unit": "g"
    },
    {
      "label": "5 g",
      "count": 5,
      "unit": "g"
    },
    {
      "label": "10 g",
      "count": 10,
      "unit": "g"
    },
    {
      "label": "20 g",
      "count": 20,
      "unit": "g"
    },
    {
      "label": "100 g",
      "count": 100,
      "unit": "g"
    },
    {
      "label": "200 g",
      "count": 200,
      "unit": "g"
    }
  ],
  "Spray": [
    {
      "label": "10 ml",
      "count": 10,
      "unit": "ml"
    },
    {
      "label": "15 ml",
      "count": 15,
      "unit": "ml"
    },
    {
      "label": "30 ml",
      "count": 30,
      "unit": "ml"
    },
    {
      "label": "50 ml",
      "count": 50,
      "unit": "ml"
    }
  ],
  "Soap": [
    {
      "label": "50 g",
      "count": 50,
      "unit": "g"
    },
    {
      "label": "75 g",
      "count": 75,
      "unit": "g"
    },
    {
      "label": "100 g",
      "count": 100,
      "unit": "g"
    }
  ],
  "Shampoo": [
    {
      "label": "50 ml",
      "count": 50,
      "unit": "ml"
    },
    {
      "label": "75 ml",
      "count": 75,
      "unit": "ml"
    },
    {
      "label": "100 ml",
      "count": 100,
      "unit": "ml"
    },
    {
      "label": "150 ml",
      "count": 150,
      "unit": "ml"
    },
    {
      "label": "200 ml",
      "count": 200,
      "unit": "ml"
    }
  ]
};
